const plateIds=new Set(['6791800225857','6753405009985','6791795441729','6796522520641','8034514534465','7891907477569','10355764461633']);
export function invalidPlateLines(items){
 const totals=new Map();
 for(const item of items){if(!plateIds.has(String(item.product_id)))continue;const id=String(item.variant_id);const old=totals.get(id)||{title:item.product_title,quantity:0};old.quantity+=item.quantity;totals.set(id,old);}
 return [...totals.values()].filter(line=>line.quantity>0&&line.quantity<4);
}
if(typeof document!=='undefined'){
 const style=document.createElement('style');style.textContent='.cart__dynamic-checkout-buttons{display:none!important}';document.head.append(style);
 let busy=false;
 const root=()=>window.Shopify?.routes?.root||'/';
 async function check(event,element){
  event.preventDefault();event.stopImmediatePropagation();if(busy)return;busy=true;
  try{
   const response=await fetch(root()+'cart.js',{credentials:'same-origin'});if(!response.ok)throw Error();const cart=await response.json();const invalid=invalidPlateLines(cart.items);
   let notice=document.getElementById('kulakCartMinimum');
   if(invalid.length){
    if(!notice){notice=document.createElement('p');notice.id='kulakCartMinimum';notice.setAttribute('role','alert');notice.tabIndex=-1;notice.style.cssText='padding:18px;background:#fff2ca;color:#243b4a;margin:20px';element.closest('form')?.prepend(notice);if(!notice.isConnected)document.body.prepend(notice);}
    notice.textContent=(window.KULAK_PURCHASE_LABELS?.cart_minimum||'Please order at least 4 plates per colour combination, or remove that colour from your cart.')+' '+invalid.map(x=>x.title+' ('+x.quantity+')').join(', ');notice.focus();notice.scrollIntoView({block:'center'});return;
   }
   location.assign(root()+'checkout');
  }catch{
   alert(window.KULAK_PURCHASE_LABELS?.cart_error||'Your cart could not be checked. Please refresh and try again.');
  }finally{busy=false;}
 }
 document.addEventListener('click',event=>{const el=event.target.closest('button[name="checkout"],input[name="checkout"],a[href*="/checkout"]');if(el)check(event,el);},true);
 document.addEventListener('submit',event=>{if(event.submitter?.name==='checkout')check(event,event.submitter);},true);
}
